import RechargeHistoryLayout from "component/my-account/recharge-history";
import MyAccountLayout from "parts/myAccountLayout";
import React from "react";

const RechargeHistory: React.FC = () => {
  return (
    <>
      <MyAccountLayout>
        <RechargeHistoryLayout />
      </MyAccountLayout>
    </>
  );
};

export default RechargeHistory;
